import React from 'react';

type ErrorProps = {
    strongText: string,
    text: string
}


export const Error = ({ strongText, text}: ErrorProps) => <aside>
    <div className="-space-y-px rounded-md shadow-sm mb-4">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <strong className="font-bold">{strongText} </strong>
            <span className="block sm:inline">{text}</span>
        </div>
    </div>
</aside>